export default __webpack_public_path__ + "static/media/MercuryGate.b6571e1f.png";